<template>
	<div class="main-page-content">
		<PageHeaderLayout >
			<div style="">
				<el-button size="mini" @click="$router.back()"> ← 返回</el-button>
			</div>
			<div style="background: #fff; margin-top: 20px">
				<el-row :gutter="48">
					<el-form :model="formData" label-width="100px">
						<el-col :span="10">
							<el-form-item label="编号：" prop="fullname">
								<div>{{ formData.id }}</div>
							</el-form-item>
							<el-form-item label="税源地名称：" prop="sex">
								<div>{{ formData.channel_account }}</div>
							</el-form-item>
							<el-form-item label="任务名称：" prop="birthday">
								<div>{{ formData.name }}</div>
							</el-form-item>
							<el-form-item label="任务类型：" prop="birthday">
								<div>{{ formData.category_name }}</div>
							</el-form-item>
							<!-- <el-form-item label="行业类型：" prop="birthday">
								<div>{{ formData.industry }}</div>
							</el-form-item> -->
							<el-form-item label="工作地点：" prop="birthday">
								<div>{{ formData.address }}</div>
							</el-form-item>
							<el-form-item label="详细地点：" prop="birthday">
								<div>{{ formData.address_detail }}</div>
							</el-form-item>
							<el-form-item label="薪资范围：" prop="birthday">
								<div>{{ formData.min_salary+'-'+formData.max_salary }}</div>
							</el-form-item>
							<el-form-item label="用工人数：" prop="birthday">
								<div>{{ formData.worked_num }}</div>
							</el-form-item>
							<el-form-item label="学历要求：" prop="birthday">
								<div>{{ formData.education }}</div>
							</el-form-item>
							<!-- <el-form-item label="提交时间：" prop="mobile">
                <div>{{ formData.created_at }}</div>
              </el-form-item> -->
						</el-col>
						<el-col :span="10"
							><el-form-item label="任务描述：" prop="category_name">
								<div
									style="
                    word-wrap: break-word;
                    word-break: break-all;
                    overflow: hidden;
                  "
								>
									{{ formData.job_remark }}
								</div>
							</el-form-item>
							<!-- <el-form-item label="任务亮点：" prop="birthday">
								<div>{{ formData.industry_type_name }}</div>
							</el-form-item> -->
							<el-form-item label="审核状态：" prop="id_number">
								<div>
									{{
										formData.examine_status == "0"
											? "审核中"
											: formData.examine_status == "1"
											? "审核成功"
											: formData.examine_status == "2"
											? "审核失败"
											: ""
									}}
								</div>
							</el-form-item>
							<el-form-item label="合作邀请码：" prop="category_name">
								<img :src="formData.code_url" alt="" disabled />
							</el-form-item>
							<el-form-item label="状态：" prop="id_number">
								<div>
									{{ formData.status  }}
								</div>
							</el-form-item></el-col
						>
					</el-form>
				</el-row>
			</div>
		</PageHeaderLayout>
	</div>
</template>
<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
const EDUCATION_TEXT = [
	"不限",
	"小学",
	"初中",
	"高中",
	"大专",
	"本科及以上",
];
const JOB_STATUS_TEXT = ["未开始", "进行中", "已完成", "已暂停"];
export default {
	components: {
		PageHeaderLayout,
	},
	data() {
		return {
			EDUCATION_TEXT,
			JOB_STATUS_TEXT,
			query:{},
			formData: {},
		};
	},
	methods: {
	async	getInfo(){
		let data={}
		if(this.query.active==='1'){
			data=await this.$api.postMissionView(this.query.id)
			data.name=data.title
			data.address_detail=data.address
			data.address=data.all_address
			data.worked_num=data.person_num
			data.job_remark=data.mission_content
			data.status =data.status== 1 ? "开启" : "关闭"
			data.channel_account=data.settlement_name
		}else{
			data=await this.$api.postDaily_taskView({id:this.query.id})
			data.name=data.recruit_post
			data.channel_account=data.channel_name
			data.status =this.JOB_STATUS_TEXT[data.status]||''
		}
			
			this.formData=data
			this.formData.education=this.EDUCATION_TEXT[data.education]||'不限'
			console.log(data)
		},
	},
	created() {},
	mounted() {
		this.query=this.$route.query
		this.formData = this.$route.query;
		this.getInfo()
		console.log(this.formData, "数据2");
	},
};
</script>
<style scoped></style>
